import {Component} from "@angular/core";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {CompanyDetailsEntityModel} from "../../company-details-entity.model";
import {TaxSearchPageComponent} from "../../../tax/tax-search-page/tax-search-page.component";
import {TaxEditPageComponent} from "../../../tax/tax-edit-page/tax-edit-page.component";
import {EditMode} from "../../../../framework/entity/edit/edit-page/edit-mode";

@Component({
    selector: "wbo-company-details-edit-taxes-receipt",
    templateUrl: "./company-details-edit-taxes-receipt.component.html"
})
export class CompanyDetailsEditTaxesReceiptComponent {
    EditMode = EditMode;
    TaxSearchPageComponent = TaxSearchPageComponent;
    TaxEditPageComponent = TaxEditPageComponent;

    constructor(public model: CompanyDetailsEntityModel, public editService: EditService) {
    }
}
